import { Link, useLocation } from 'react-router-dom';

function LinkComponent({ path, label }) {
  const { pathname } = useLocation();
  return (
    <li className="nav-item">
      <Link
        to={path}
        className={`nav-link Ripple-parent ${
          pathname === path ? 'active' : ''
        }`}
      >
        {label}
      </Link>
    </li>
  );
}

export default LinkComponent;
